<template>
  <div>
    <div
      :key="ind"
      v-for="(item, ind) in arrayValues"
      class="grid"
      :style="{
        'grid-template-columns': `repeat(${
          Object.keys(fields).length + 1
        }, 1fr)`,
      }"
    >
      <el-input
        :key="i"
        v-for="(value, i) in item"
        class="input-new-tag"
        :value="value"
        size="small"
        :disabled="true"
      />
      <el-button
        type="danger"
        class="button-new-tag"
        size="small"
        @click="handleClose(ind)"
        >Удалить</el-button
      >
    </div>
    <div
      class="grid"
      :style="{
        'grid-template-columns': `repeat(${visibleFieldKeys.length + 1}, 1fr)`,
      }"
    >
      <el-input
        v-for="key in visibleFieldKeys"
        :key="key"
        class="input-new-tag"
        v-model="fieldsValues[key]"
        size="small"
        :placeholder="fields[key].title"
        :type="fields[key].type"
        :ref="`input-${key}`"
        :required="fields[key].required"
        :class="[
          !fields[key].required ? 'not-required' : '',
          errors[key] ? 'has-error' : '',
        ]"
      >
      </el-input>
      <el-button
        class="button-new-tag"
        size="small"
        :disabled="!canAdd"
        @click="addButton"
        >Добавить</el-button
      >
    </div>
    <div v-if="isRelatedMode" class="hint-msg">
      Можно добавить не более {{ maxItems }} связанных публикаций.
    </div>
    <div v-if="errors.related_publication" class="error-msg">
      {{ errors.related_publication }}
    </div>
  </div>
</template>

<script>
import { getPublication } from "@/api/publication";

export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    fields: {
      type: Object,
      required: true,
      default: () => {},
    },
    buttonName: {
      type: String,
      required: false,
      default: "+",
    },
    buttonWidth: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  computed: {
    arrayValues: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    visibleFieldKeys() {
      return Object.keys(this.fields).filter(
        (key) => !this.fields[key].readonly
      );
    },
    isRelatedMode() {
      return !!this.fields.related_publication;
    },
    maxItems() {
      return this.isRelatedMode ? 3 : Infinity;
    },
    canAdd() {
      return this.arrayValues.length < this.maxItems;
    },
  },
  data() {
    return {
      fieldsValues: {},
      errors: {},
    };
  },
  created() {
    this.createValues();
  },
  methods: {
    createValues() {
      let keys = Object.keys(this.fields);
      for (let key of keys) {
        if (this.fields[key].type == "number")
          this.$set(this.fieldsValues, key, null);
        else this.$set(this.fieldsValues, key, "");
      }
    },
    cleareValues() {
      for (let key in this.fieldsValues) this.fieldsValues[key] = "";
      this.errors = {};
    },
    handleClose(ind) {
      this.arrayValues.splice(ind, 1);
    },
    // showInput() {
    //   this.inputVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.saveTagInput.$refs.input.focus();
    //   });
    // },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.$emit("input", this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    async addButton() {
      this.errors = {};

      if (!this.canAdd) {
        if (this.isRelatedMode) {
          this.$set(
            this.errors,
            "related_publication",
            `Можно добавить не более ${this.maxItems} связанных публикаций`
          );
        }
        return;
      }

      for (let key in this.fields) {
        if (this.fields[key].required && !this.fieldsValues[key]) {
          this.$refs[`input-${key}`][0].$el.children[0].classList.add(
            "required"
          );
          this.$set(this.errors, key, "Поле обязательно для заполнения");
          return;
        }
      }

      // Специальная логика для связанных публикаций:
      if (this.fields.related_publication) {
        const id = this.fieldsValues.related_publication;
        if (
          this.arrayValues.some(
            (item) =>
              item &&
              String(item.related_publication) ===
                String(this.fieldsValues.related_publication)
          )
        ) {
          this.$set(this.errors, "related_publication", "Уже добавлено");
          return;
        }
        try {
          const publication = await getPublication(id);
          const obj = {
            related_publication: id,
            related_publication_title: publication.title || "",
          };
          this.arrayValues.push(obj);
          this.cleareValues();
          this.$emit("input", this.arrayValues);
        } catch (e) {
          this.$set(
            this.errors,
            "related_publication",
            "Публикация с таким ID не найдена"
          );
        }
        return;
      }

      const obj = {};
      Object.assign(obj, this.fieldsValues);
      this.arrayValues.push(obj);
      this.cleareValues();
      this.$emit("input", this.arrayValues);
    },
  },
};
</script>

<style scoped>
.el-tag {
  margin-right: 10px;
}
.button-new-tag {
  margin-right: 10px;
}
.input-new-tag {
  margin-right: 10px;
  line-height: initial;
}
.grid {
  display: grid;
  grid-gap: 5px;
  margin-bottom: 5px;
}
.required {
  border-color: red;
}
.has-error input {
  border-color: red;
}
.error-msg {
  color: #f56c6c;
  font-size: 12px;
}
.hint-msg {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}
</style>
